var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.loading } }, [
    _c(
      "div",
      { staticClass: "d-flex justify-content-center align-items-center" },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Desplegar acciones",
                expression: "'Desplegar acciones'"
              }
            ]
          },
          [
            _c(
              "b-dropdown",
              {
                attrs: { variant: "link", "no-caret": "", right: "" },
                scopedSlots: _vm._u([
                  {
                    key: "button-content",
                    fn: function() {
                      return [
                        _c("feather-icon", {
                          staticClass: "align-middle text-body",
                          attrs: {
                            "data-cy": "gear-button",
                            width: "24px",
                            height: "24px",
                            icon: "SettingsIcon"
                          }
                        })
                      ]
                    },
                    proxy: true
                  }
                ])
              },
              [
                _c(
                  "CheckPermission",
                  { attrs: { permission: "WBF102" } },
                  [
                    _c(
                      "b-dropdown-item",
                      {
                        attrs: { "data-cy": "binnacle" },
                        on: {
                          click: function($event) {
                            return _vm.onOptionBinnacleFile()
                          }
                        }
                      },
                      [
                        _c("vs-icon", { attrs: { icon: "list" } }),
                        _vm._v(" Bitácora ")
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "CheckPermission",
                  { attrs: { permission: "WBF103" } },
                  [
                    _c(
                      "b-dropdown-item",
                      {
                        attrs: { "data-cy": "preview" },
                        on: {
                          click: function($event) {
                            return _vm.previewBillin()
                          }
                        }
                      },
                      [
                        _c("vs-icon", { attrs: { icon: "visibility" } }),
                        _vm._v(" Previsualizar ")
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "CheckPermission",
                  { attrs: { permission: "WBF104" } },
                  [
                    _c(
                      "b-dropdown-item",
                      {
                        attrs: { "data-cy": "edit" },
                        on: {
                          click: function($event) {
                            return _vm.editBilling()
                          }
                        }
                      },
                      [
                        _c("vs-icon", { attrs: { icon: "edit" } }),
                        _vm._v(" Editar ")
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("span")
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }